<script lang="ts">
  import type { ClientUserStore } from 'shared/src';

  import type { UserLessonStore } from 'shared/src/user/userLessons/user.lesson.store';
  import HtmlLessonContent from './HtmlLessonContent.svelte';
  import VideoLessonContent from './VideoLessonContent.svelte';
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import InteractiveLessonContent from './InteractiveLessonContent.svelte';
  import type { UPracticeData } from 'shared/definitions/progress-data';
  import { pauseUserStoreRefresh, resumeUserStoreRefresh } from '$lib/stores/getUserStore';

  export let lessonPage: UserLessonStore['pages'][number];
  export let clientUserStore: ClientUserStore;

  interface $$Events {
    contentEnded: CustomEvent<UPracticeData[] | undefined>;
    contentError: any;
    timeSpent: CustomEvent<number>;
  }
  const dispatch = createEventDispatcher<$$Events>();

  onMount(pauseUserStoreRefresh);
  onDestroy(resumeUserStoreRefresh);
</script>

<div
  class="lesson-content-card card p-4 mb-4 {lessonPage.type === 'Video'
    ? 'aspect-video'
    : ''} mx-auto"
>
  {#if lessonPage.type === 'Info'}
    <HtmlLessonContent {lessonPage} on:contentEnded={() => dispatch('contentEnded')} />
  {:else if lessonPage.type === 'Video'}
    <VideoLessonContent
      {lessonPage}
      {clientUserStore}
      on:video404={(err) => {
        dispatch('contentError', err);
      }}
      on:videoEnded={() => dispatch('contentEnded')}
    />
  {:else if lessonPage.type === 'Practice'}
    <InteractiveLessonContent
      {clientUserStore}
      name={lessonPage.interactive?.type}
      options={lessonPage.interactive}
      on:contentEnded
      on:contentError
      on:timeSpent
    />
  {:else}
    Lesson Content
  {/if}
</div>

<style lang="postcss">
  .lesson-content-card {
    :global(&.aspect-video) {
      max-height: calc(100vh - 9rem);
    }
  }
</style>
